import Header from '../Header/Header'
import blogBg from '../../../assets/images/developmentlanguage/blogbg.webp'

type BlogDetailsHeroSectionProps = {
  title: string
  subtitle?: string
}

const BlogDetailsHeroSection = ({ title, subtitle }: BlogDetailsHeroSectionProps) => {
  return (
    <section className="relative min-h-[80vh] overflow-hidden ">
      <img
        src={blogBg}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="relative z-20">
        <Header />
      </div>

      <div className="absolute bottom-0 left-0 z-20 h-1 w-full bg-purple md:h-[4px]" />
    </section>
  )
}

export default BlogDetailsHeroSection
